// A cell's tooltip is a separate DOM node from the cell itself, so opening it
// doesn't automatically pick up content set after the initial render (e.g.
// notes edited elsewhere) - this re-reads the cell and pushes it into
// whichever tooltip node is currently mounted for that column.
const useCellTooltipSync = (rowId) => (col) => {
	const cellElement = document.querySelector(`#taskExpandable${rowId} > #dataCell${col} > div > p`);
	if (!cellElement) return;

	// For notes use innerHTML, for others use textContent
	const cellContent = col === "notes" ? cellElement.innerHTML : cellElement.textContent;

	// Use a small delay to ensure tooltip is rendered in DOM
	setTimeout(() => {
		// Try multiple selectors to find the tooltip content div
		const selectors = [`#tooltip-${col} > div`, `[id^="tooltip-${col}"] div`, `.MuiTooltip-tooltip div`];

		for (const selector of selectors) {
			const tooltipDivs = document.querySelectorAll(selector);
			if (tooltipDivs.length > 0) {
				// Update the innermost div (last one)
				const targetDiv = tooltipDivs[tooltipDivs.length - 1];
				if (targetDiv) {
					targetDiv.innerHTML = cellContent;
					break;
				}
			}
		}
	}, 10);
};

export default useCellTooltipSync;
